import React, { Component } from 'react';
import {connect} from 'react-redux';
import {withRouter} from 'react-router-dom';
import { translate } from 'react-i18next';

import DatabaseService from 'services/DatabaseService.js';
import {SET_LOADING_OVERLAY_ENABLE} from 'actions/types';
import {fetchMyProfile} from 'actions/user.js';
import {initNavbarState} from 'actions/navbar.js';

import MyHealth from './MyHealth.js';

class MyHealthContainer extends Component {
    constructor(props) {
        super(props);
        this.state={survey:null, 
                    selectedSurveyPage:null,
                    busy:false, 
                    error:''};
        this.onSelectSurveyPage = this.onSelectSurveyPage.bind(this);
        this.onCloseModal = this.onCloseModal.bind(this);
        this.onModalUpdateComplete = this.onModalUpdateComplete.bind(this);
    }

    componentWillMount() {
        this.props.dispatch(initNavbarState({enable:true, menuEnable:false, backButtonEnable:true, rewardsEnable:false, title:this.props.t('Health Stats')}));
        this.props.dispatch({type:'SET_SIDEBAR_ENABLE', enable:false});
        this.loadData();
    }

    loadData() {
        this.setState({busy:true});
        DatabaseService.getSurvey(this.props.surveyId || this.props.match.params.id, this.props.micro).then((result) => {
                                var survey = result.survey;
                                var surveyPages = survey.surveyPages;
                                var numPages = surveyPages.length;
                                this.setState({survey:survey, numPages});
                                return this.props.dispatch(fetchMyProfile({health:true}));
                            }).catch((error)=>{
                                console.error("Error: ", error);
                                this.setState({error:String(error)});
                            }).then(()=>{
                                this.setState({busy:false});
                            });
    }
    onSelectSurveyPage(surveyPage) {
        this.setState({selectedSurveyPage:surveyPage});
    }
    onCloseModal() {
        this.setState({selectedSurveyPage:null});
    }
    onModalUpdateComplete() {
        this.loadData();
        this.setState({selectedSurveyPage:null});
    }
    render() {
        return <MyHealth
                    userHealth={this.props.userHealth}
                    survey={this.state.survey}
                    selectedSurveyPage={this.state.selectedSurveyPage}
                    onSelectSurveyPage={this.onSelectSurveyPage}
                    onCloseModal={this.onCloseModal}
                    onModalUpdateComplete={this.onModalUpdateComplete}/>;
    }

}

function mapStateToProps(state, ownProps) {

    var healthLoaded = state.user.hasOwnProperty('health');
    return { healthLoaded: healthLoaded, 
             userHealth: state.user.health };
}

export default translate('surveys')(connect(mapStateToProps)(withRouter(MyHealthContainer)));



// WEBPACK FOOTER //
// ./src/modules/surveys/MyHealthContainer.js